//import vue instance
window.Vue = require("vue");

// Import external library
require("./bootstrap");
import "./plugin/bootstrap-vue";
import "./plugin/days";
import "./plugin/sweetalert2";
import "./plugin/v-select";
// import "./plugin/ck-editor";
import "./plugin/vue-image-upload-resize";
import "./plugin/vue-quagga";
import "./plugin/vue-number-format";
import "./plugin/vue2-google-maps";
import "./plugin/ckeditor4";

// Import utilities
import { apiRequest, get, post, put, del, clearApiCache } from './utils/api';
// import { realtime } from './utils/realtime';

// Make utilities globally available
window.api = { apiRequest, get, post, put, del, clearApiCache };
// window.realtime = realtime;

// Add request interceptor
window.axios.interceptors.request.use(
    config => {
        // Add cache-busting parameter to GET requests
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                _: Date.now()
            };
            
            // Don't cache API requests
            config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
            config.headers['Pragma'] = 'no-cache';
            config.headers['Expires'] = '0';
        }
        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Add response interceptor
window.axios.interceptors.response.use(
    response => {
        // Clear any cached data for this URL after successful update
        if (['post', 'put', 'delete', 'patch'].includes(response.config.method)) {
            clearApiCache(response.config.url);
        }
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

//Import global function
import "./plugin/global-function";

//import initial global component setting
import "./importComponent";

//import store file (vuex)
import store from "./store";

//import routes file (routing)
import routes from "./routes/main";

//setting vue routing
import VueRouter from "vue-router";
Vue.use(VueRouter);
const router = new VueRouter({
    mode: "history",
    routes,
});

// export all setting
const app = new Vue({
    el: "#app",
    router,
    store,
});
